export default __webpack_public_path__ + "static/media/image003.c5e6f97a.jpeg";